import { ErrorLogComponent } from '@cian/error-log-component';

import { clsx } from 'clsx';
import { Children, type FC, type JSX } from 'react';

import { useApplicationContext } from 'shared/utils/applicationContext';

import styles from './ContentWrapper.css';

interface IContentWrapperProps {
  children: (JSX.Element | null)[];
  topOffset: 'content' | 'header';
}

export const ContentWrapper: FC<IContentWrapperProps> = ({ children, topOffset }) => {
  const { logger } = useApplicationContext();

  return (
    <div className={clsx(styles['wrapper'], topOffset === 'content' && styles['wrapper--content-offset'])}>
      {Children.map(children, child => (child ? <ErrorLogComponent logger={logger}>{child}</ErrorLogComponent> : null))}
    </div>
  );
};
